module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"belt":"belte","noBelt":" ","viewLeaderboard":"View leaderboard","yourRank":"Your Rank"},"en":{"belt":"belt","noBelt":" ","viewLeaderboard":"View leaderboard","yourRank":"Your Rank"}}')
  delete Component.options._Ctor
}
